import type {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

export type AdvertisementPlatform = {
  code: AdvertisingPlatformCodeEnum;
  title: string;
  enabled: boolean;
};
